/**
 * 公共变量
 */
export const commonConst = {
  TENANT_ID: '2',  //租户id
  YES:'10020001',//是
  NO:'10020002',//否
  ENABLE: "90110001",// 启用
  DISABLED: "90110002",// 禁用
  PAY_STATUS_PAYING:"92530001",//发放中
  PAY_STATUS_PAYFINISH:"92530002",//已发/发放完成
  PAY_STATUS_WAITING:"92530004",//待发放
  PAY_STATUS_NOTPAY:"92530003",//不发
  PAY_STATUS_CACHE:"92530005",//暂缓
  PAY_STATUS_RETURNTICKET:"92530006",//有退票
  THE_CURRENT_MONTH : "92480001", //当前月
  THE_THREE_MONTH :"92480002", //近三月
  THE_YEAR : "92480003", //近一年
  THE_HISTORY : "92480004", //历史
  PAY_WAY_UNDERLINE:"92500003",//线下发薪
  PAY_WAY_SYSTEM:"92500004",//系统发薪
  COMPANY_NEXT_MONTH:"92540002",//次月
  COMPANY_CURRENT_MONTH:"92540001",//当月
  INFO_ITEM_DATA_TYPE_INT :"92420001",   //整数
  INFO_ITEM_DATA_TYPE_FLOAT : "92420002", //小数
  INFO_ITEM_DATA_TYPE_STRING : "92420003",//文本
  INFO_ITEM_DATA_TYPE_DATE8 : "92420004", //yyyy-MM-dd 8位日期
  INFO_ITEM_DATA_TYPE_CODE : "92420005",  //代码
  INFO_ITEM_VALUE_NOT_NULL : "10020001",  //值不能为空
  WAGE_PROC_SEG_ONGLY_PAY : "proc_0010",  //仅工资条
  WAGE_TEMPID_ONLY_PAY : "111111",  //仅工资条系统模板
  WAGE_PROC_SEG_COMPUTE_RECORD : "seg_00010001",  //数据准备
};
